import {
  IParamsGetActionByEvent,
  IParamsGetActionRegisteredByMember,
  IParamsGetEvents,
  IParamsGetMemberByAction,
  IParamsGetRegisterTeam,
} from 'app/api/event/model'

export const EventKeys = {
  allEvents: ['Events'] as const,
  listEvents: () => [...EventKeys.allEvents, 'listEvents'] as const,
  listEvent: (filter?: IParamsGetEvents) =>
    [...EventKeys.listEvents(), { filter }] as const,

  allEventsWithTum: ['EventsWithTum'] as const,
  listEventsWithTum: () =>
    [...EventKeys.allEventsWithTum, 'listEventsWithTum'] as const,
  listEventWithTum: (filter?: IParamsGetEvents) =>
    [...EventKeys.listEventsWithTum(), { filter }] as const,

  allTradeUnionMembers: ['TradeUnionMembers'] as const,
  listTradeUnionMembers: () =>
    [...EventKeys.allTradeUnionMembers, 'listTradeUnionMembers'] as const,
  listTradeUnionMember: (filter?: IParamsGetEvents) =>
    [...EventKeys.listTradeUnionMembers(), { filter }] as const,

  allActionsByEvent: ['ActionsByEvent'] as const,
  listActionsByEvent: () =>
    [...EventKeys.allActionsByEvent, 'listActionsByEvent'] as const,
  listActionEvent: (filter?: IParamsGetActionByEvent) =>
    [...EventKeys.listActionsByEvent(), { filter }] as const,

  allActionsNotJoinByEvent: ['ActionsByEvent'] as const,
  listActionsNotJoinByEvent: () =>
    [
      ...EventKeys.allActionsNotJoinByEvent,
      'listActionsNotJoinByEvent',
    ] as const,
  listActionNotJoinEvent: (filter?: IParamsGetActionByEvent) =>
    [...EventKeys.listActionsNotJoinByEvent(), { filter }] as const,

  allListMemberOfReward: ['ListMemberOfReward'] as const,
  listListMemberOfReward: () =>
    [...EventKeys.allListMemberOfReward, 'listListMemberOfReward'] as const,
  listListMemberOfRewards: (filter?: IParamsGetActionByEvent) =>
    [...EventKeys.listListMemberOfReward(), { filter }] as const,

  allListTeamOfReward: ['ListTeamOfReward'] as const,
  listListTeamOfReward: () =>
    [...EventKeys.allListTeamOfReward, 'listListTeamOfReward'] as const,
  listListTeamOfRewards: (filter?: IParamsGetActionByEvent) =>
    [...EventKeys.listListTeamOfReward(), { filter }] as const,

  allListActionNotJoinByMember: ['ListActionNotJoinByMember'] as const,
  listListActionNotJoinByMember: () =>
    [
      ...EventKeys.allListActionNotJoinByMember,
      'listListActionNotJoinByMember',
    ] as const,
  listListActionNotJoinByMembers: (id?: number) =>
    [...EventKeys.listListActionNotJoinByMember(), { id }] as const,

  allListActionRegisteredByMember: ['ListActionRegisteredByMember'] as const,
  listListActionRegisteredByMember: () =>
    [
      ...EventKeys.allListActionRegisteredByMember,
      'listListActionRegisteredByMember',
    ] as const,
  listListActionRegisteredByMembers: (
    filter?: IParamsGetActionRegisteredByMember,
  ) => [...EventKeys.listListActionRegisteredByMember(), { filter }] as const,

  allListAllActionByMember: ['ListAllActionByMember'] as const,
  listListAllActionByMember: () =>
    [
      ...EventKeys.allListAllActionByMember,
      'listListAllActionByMember',
    ] as const,
  listListAllActionByMembers: (filter?: IParamsGetActionRegisteredByMember) =>
    [...EventKeys.listListAllActionByMember(), { filter }] as const,

  allMemberRegisterByAction: ['MemberRegisterByAction'] as const,
  listMemberRegisterByAction: () =>
    [
      ...EventKeys.allMemberRegisterByAction,
      'listMemberRegisterByAction',
    ] as const,
  listMemberRegisterByActions: (filter?: IParamsGetMemberByAction) =>
    [...EventKeys.listMemberRegisterByAction(), { filter }] as const,

  allListActionNotJoinByTeam: ['ListActionNotJoinByTeam'] as const,
  listListActionNotJoinByTeam: () =>
    [
      ...EventKeys.allListActionNotJoinByTeam,
      'listListActionNotJoinByTeam',
    ] as const,
  listListActionNotJoinByTeams: (id?: number) =>
    [...EventKeys.listListActionNotJoinByTeam(), { id }] as const,

  allListActionRegisteredByTeam: ['ListActionRegisteredByTeam'] as const,
  listListActionRegisteredByTeam: () =>
    [
      ...EventKeys.allListActionRegisteredByTeam,
      'listListActionRegisteredByTeam',
    ] as const,
  listListActionRegisteredByTeams: (filter?: IParamsGetRegisterTeam) =>
    [...EventKeys.listListActionRegisteredByTeam(), { filter }] as const,
}
